import * as fromDatatype from '../datatype-library';

export interface bl_wf_issue_worklog_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  duration: fromDatatype.NumericDatatypeInterface;
  log_date: fromDatatype.TimestampTzDatatypeInterface;
  guid_issue: fromDatatype.GuidDataFieldInterface;
  guid_user: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_wf_issue_worklog_hdr_RowClass
  implements bl_wf_issue_worklog_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  duration: fromDatatype.NumericDatatypeInterface;
  log_date: fromDatatype.TimestampTzDatatypeInterface;
  guid_issue: fromDatatype.GuidDataFieldInterface;
  guid_user: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
